import * as PIXI from 'pixi.js';
//imported so that pixi can fall back to canvas if web gl is not supported
import * as PIXI_LEGACY from 'pixi.js-legacy';

export default class PixiRenderer {
    constructor(config) {
        this.app = new PIXI.Application(config);
        this.app.stage.sortableChildren = true;
    }

    getDomElement() {
        return this.app.view;
    }

    getStage() {
        return this.app.stage;
    }

    getContext() {
        return this.app.renderer.gl;
    }

    setSize(width, height) {
        this.app.renderer.resize(width, height);
    }

    getExtractedCanvas() {
        var area = this.app.renderer.screen;
        var texture = this.app.renderer.generateTexture(this.getStage(), undefined, undefined, area);
        var canvas = this.app.renderer.extract.canvas(texture);
        texture.destroy(true);
        
        return canvas;
    }
}
